<div class="st">
  <div class="st__head">
    <div>
      <p class="st__title">Estruturas de participação</p>
      <p class="st__sub">
        Pessoas jurídicas que constam como sócias em duas ou mais empresas do recorte.
      </p>
    </div>
    <span class="st__count"
      >{{ visao().estruturas.length }}
      {{ visao().estruturas.length === 1 ? 'estrutura' : 'estruturas' }}</span
    >
  </div>

  @for (e of visao().estruturas; track e.socio.id) {
    <div class="st__row">
      <div class="st__who">
        @if (display.showHoldingBadge()) {
          <span class="holding">Possível holding</span>
        }
        <p class="st__name">{{ e.socio.nome }}</p>
        @if (ehCnpj(e.socio.documento)) {
          <p class="st__doc">{{ e.socio.documento! | vaultMaskCnpj }}</p>
        }
        <p class="st__qual">Qualificação no QSA: {{ e.socio.qualificacao || 'Sócio' }}</p>
      </div>
      <div class="st__companies">
        <span class="eyebrow">Consta como sócia em {{ e.empresas.length }} empresas</span>
        <div class="st__chips">
          @for (emp of e.empresas; track emp.cnpj || emp.basico) {
            <span class="chip">{{ emp.nome }}</span>
          }
        </div>
      </div>
    </div>
  } @empty {
    <div class="st__empty">
      Nenhuma pessoa jurídica aparece como sócia de mais de uma empresa neste recorte. Aumente a
      profundidade para ampliar a análise.
    </div>
  }

  <p class="st__foot">
    A classificação é um indício estrutural: confirma que a PJ participa de várias empresas, mas não
    substitui a verificação do objeto social, CNAEs, quadro de capital e controle efetivo.
  </p>
</div>
